import { setDocTitle } from "../../../functions/HelperFuncs";

export default {
  data() {
    return {
      company: this.$store.state.company,
      activePage: null,
      pages: [
        {
          id: "sfgfgfgdfgdfg",
          title: "Privacy & Legal",
          body: `
          <h3>General</h3>
          <p>
          SHEPRD is a platform that was developed by Noticed
          Communicatiebureau, whose main office is at 2500 Lier,
          Lintsesteenweg 105 and whose commercial ID number is
          0806.663.876 (“Noticed”) for saving and sharing files
          (“SHEPRD”). SHEPRD is offered as software-as-a-service and
          is therefore a service of Noticed.
        </p>
        <p>
          By registering for SHEPRD or using SHEPRD, the client
          affirms that he will adhere to the terms of use laid out
          below and the client confirms that he has received, read and
          assented to their content.
        </p>
        <p>
          If the client does not agree with any provision in the terms
          of use, then he must refrain from using SHEPRD.
        </p>
        <p>
          The nullity of one or more provisions from these terms of
          use or any part of them whatsoever does not render the
          remaining clauses invalid or unenforceable.
        </p>
        <p>
          Noticed reserves to itself the right to modify its terms of
          use at its own discretion by making a change on this page.
          The client will be informed of this within a reasonable
          period of time before the changed terms of use take effect.
        </p>

        <h5>1. Description SHEPRD</h5>
        <p>
          1.1 SHEPRD is a digital platform on which the client can
          store and share client data with third parties. SHEPRD is
          offered as a service by Noticed in the form of
          software-as-a-service.
        </p>
        <p>
          1.2 The term ‘client data’ refers to all information which
          is generated or stored using SHEPRD, including but not
          limited to databases, documents, illustrations, video
          recordings.
        </p>

        <h5>2. Concluding an agreement</h5>
        <p>
          2.1 To be able to use SHEPRD, the client must set up an
          account. When setting up the account, one can chose from a
          variety of subscription formula. The price of a subscription
          differs based on the formula chose as a function of the
          storage capacity and the functionalities. Noticed makes the
          different subscription formulas with the matching price
          available on its
          <a href="/#pricing">website</a>.
        </p>
        <p>
          2.2 As soon as the payment owed for the subscription chosen
          has been paid, the agreement is concluded between the client
          and Noticed and the initial subscription period begins.
        </p>

        <h5>3. Period</h5>
        <p>
          3.1 A subscription period is always d 1 month and will be
          passively renewed monthly unless the subscription is
          actively cancelled before the end of the current
          subscription period.
        </p>
        <p>
          3.2 Cancellation takes effect the day after the last day of
          the current subscription period. From that point, the
          exit-rules as described in article 11 will apply.
        </p>
        <p>
          3.3 In the event that an agreement is cancelled, the amounts
          already paid to SHEPRD will be kept by Noticed and will not
          be refunded, except in the case that the client chose to pay
          for a whole year in advance. In that case, the sum of the
          remaining amount will be calculated pro rata and a refund
          can be granted.
        </p>

        <h5>4. Price and payment</h5>
        <p>
          4.1 SHEPRD is offered at a fixed monthly price as described
          on the <a href="/#pricing">website</a>. The price is always
          dependent on the subscription formula chosen.
        </p>
        <p>
          4.2 The prices are expressed in Euros and do not include
          VAT.
        </p>
        <p>
          4.3 Noticed can change the price of the subscriptions from
          time to time. Clients shall always be informed in advance of
          every change in price and, if applicable, informed about how
          the changes can be accepted. Price changes shall take effect
          at the start of the subscription period following the date
          of the price change.
        </p>
        <p>
          4.4 Payment for the subscription must always be paid monthly
          in advance. The client can elect to pay for a year in
          advance. Payment is always rendered using a credit card.
        </p>
        <p>
          4.5 The compensation for the following subscription period
          will be credited the week prior to the last day of the
          current subscription period.
        </p>
        <p>
          4.6 On default of payment before the start of a new
          subscription period, the agreement will be deemed to have
          been terminated. From that moment on, the exit rules apply
          as described in article 11.
        </p>

        <h5>5. Use of SHEPRD</h5>
        <p>
          5.1 Noticed grants the client the non-exclusive and
          non-transferrable right to use SHEPRD taking into account
          the conditions and restrictions as described in these terms
          of use.
        </p>
        <p>
          5.2 The client may only use SHEPRD for data processing in
          his own business and business that are affiliated with the
          client as described in article 1:20 WVV, but not if that use
          can lead to any form of exploitation of SHEPRD – whether or
          not commercial.
        </p>
        <p>
          5.3 The client may not publish SHEPRD, nor copy it nor in
          any other way reproduce it or modify it.
        </p>
        <p>
          5.4 The client shall not use SHEPRD in a manner that causes
          damage to the platform or can damage it or which restricts
          or can restrict availability and access to the platform.
        </p>

        <h5>6. Administrator account</h5>
        <p>
          6.1 The client shall be able to access to SHEPRD using an
          administrator account. The term ‘administrator account’ will
          be understood to mean the client’s account that gives access
          to the section of SHEPRD that is reserved for the client and
          to which access is granted using the client’s
          administrator-login.
        </p>
        <p>
          6.2 The administrator account enables the client to add new
          users to SHEPRD who will also be able to access that section
          of SHEPRD that is reserved for the client. Likewise, the
          client is able to adapt the accounts to his own preferences.
        </p>
        <p>
          6.3 The client shall make reasonable efforts including
          taking adequate security measures with respect to the access
          data for the administrator account, in order to assure that
          no unauthorised persons can get access to SHEPRD.
        </p>
        <p>
          6.4 The client bears full responsibility for the content of
          client data and the use of SHEPRD.
        </p>

        <h5>7. Confidentiality</h5>
        <p>
          7.1 During the use of SHEPRD, Noticed guarantees that the
          exchange of client data between the client and a third party
          will always be confidential. Different “spaces” can be
          created in the use of the platform. The client always has
          the option of making such a space public or private.
        </p>
        <p>
          7.2 Spaces which are identified as “private” by the client
          can only be accessed by the client. In that case Noticed has
          no access to the client data in this space.
        </p>
        <p>
          7.3 Noticed shall in no case gain knowledge of the client
          data unless the client orders us to access it or Noticed is
          required to in the context of a legal obligation.
        </p>

        <h5>8. Intellectual property</h5>
        <p>
          8.1 The client acknowledges that Noticed is and remains the
          sole owner of SHEPRD. The rights that are granted to the
          client only constitute a use right (in return for
          compensation).
        </p>
        <p>
          8.2 Under no circumstances does such a right include a
          transfer of ownership rights to SHEPRD.
        </p>
        <p>
          8.3 Noticed does not claim any ownership to client data
          which is stored or shared using SHEPRD. The client bears
          sole and complete responsibility with respect to the content
          of client data.
        </p>

        <h5>9. Availability of SHEPRD</h5>
        <p>
          9.1 Noticed guarantees that it will act to the best of its
          ability to make SHEPRD available to the client. However,
          Noticed cannot guarantee that SHEPRD will function
          constantly, without interruption and perfectly.
        </p>
        <p>
          9.2 If problems should arise with the availability of SHEPRD
          then Noticed pledges that it will do its best to solve the
          problem as rapidly as possible without offering any
          guarantee to this effect.
        </p>
        <p>
          9.3 Noticed reserves the right at any time and periodically
          to interrupt, restrict or suspend operation of SHEPRD
          temporarily for a reasonable period. In this case, Noticed
          shall notify the client of this in writing.
        </p>

        <h5>10. Data protection</h5>
        <p>
          10.1 The processing of the personal data of the client
          and/or his employees by Noticed shall proceed in accord with
          Noticed’s declaration of privacy.
        </p>
        <p>
          10.2 As far are the processing of client data is concerned,
          the client acknowledges that he always acts as the
          controller and Noticed as the processor.
        </p>
        <p>
          10.3 Noticed will process Client data solely in conformity
          with the client’s instructions, as described in Article 1,
          unless Noticed is required to act otherwise based on legal
          or regulatory obligations. The client bears the full
          responsibility with respect to the lawful processing of
          client data.
        </p>
        <p>
          10.4 Noticed is obligated to always treat client data
          confidentially. Employees of Noticed are also subject to
          this confidentiality obligation.
        </p>
        <p>
          10.5 Noticed is obligated to the best of its ability to take
          suitable technical and organisational measures to secure the
          client data and processing of it. Specifically, Noticed
          shall secure the client data against destruction, loss,
          unauthorised access, unauthorised modification, unauthorised
          distribution and any other kind of illegal processing. An
          overview of the security measures taken can always be
          obtained on first request.
        </p>
        <p>
          10.6 Noticed pledges to make sure that only its employees
          have access to the client data. Noticed will restrict access
          to employees for whom access is necessary in order to
          perform their function.
        </p>
        <p>
          10.7 Noticed can engage sub-contractors, being
          sub-processors for executing certain activities that
          constitute the object of this agreement. An overview of the
          sub-processors can always be obtained on first request. If
          the current sub-contractors are changed, Noticed will notify
          the client concerning the change. The client can object to
          new sub-processors in writing within five working days of
          the notification by Noticed. Noticed guarantees that it will
          only work with sub-processors who can provide the same level
          of data protection as the security measures offered by
          Noticed. Noticed will also conclude with these
          sub-processors an agreement which imposes the same
          obligations concerning data protection as those that are
          described in this article.
        </p>
        <p>
          10.8 Noticed will support the client in fulfilling his
          obligation on respond to requests to exercise the rights of
          parties affected.
        </p>
        <p>
          10.9 If a breach of personal data such as described in the
          General Data Protection Law occurs with respect to client
          data, then Noticed pledges to notify the client of this
          within 48 hours after become aware of the breach. Noticed
          shall provide all possible reasonable assistance to the
          client to the end of ascertaining the severity and possible
          consequences of a breach of personal data for the client.
        </p>
        <p>
          10.10 Once the agreement terminates, the client data will be
          deleted within one month.
        </p>

        <h5>11. Termination of the agreement</h5>
        <p>
          11.1 Noticed can terminate the agreement without prior
          notice and with immediate effect or suspend access to SHEPRD
          if the client uses SHEPRD for unauthorised, illegal and/or
          improper purposes or if the client violates the terms of use
          for SHEPRD.
        </p>
        <p>
          11.2 Noticed can terminate the agreement after prior notice
          in the case of a general discontinuation of SHEPRD. In this
          case, the client can continue to make use of SHEPRD for the
          current subscription period, but it shall no longer be
          renewed. Once the current subscription period ends, the
          exit-rule from Article 12 takes effect.
        </p>
        <p>
          11.3 Noticed can by no means be held responsible for the
          termination of an agreement on the basis of the reasons
          spelled out in Article 10. Repayment in case of prepayment
          for an entire year of service?
        </p>

        <h5>12. Exit-rule</h5>
        <p>
          12.1 Unless otherwise agree on, Noticed shall delete the
          client data after a period of 1 month after the expiration
          or termination of the agreement.
        </p>
        <p>
          12.2 During this period, the client can transfer his data to
          another external system. The client acknowledges that he is
          responsible for any loss of data that is a consequence of
          this migration. Noticed does not offer any support for
          migrating client data to another platform.
        </p>

        <h5>13. Liability</h5>
        <p>
          13.1 The liability of Noticed is always limited to the cost
          price of a subscription period of 1 month.
        </p>
        <p>
          13.2 Noticed is not liable for any damage that is a result
          of the untimely availability, suspension, interruption or
          delay of SHEPRD. Neither is Noticed responsible for damage,
          loss or deletion of client data.
        </p>
        <p>
          13.3 The provisions of this Article 13 do not limit the
          liability of Noticed for any intentional wrongdoing or
          deception.
        </p>
        <p>
          13.4 Noticed is under no circumstances liable in cases of
          where force majeure applies.
        </p>

        <h5>14. Applicable law</h5>
        <p>
          This agreement, its execution and interpretation will be
          subject to Belgian law.
        </p>
        <p>
          Disagreements which may arise in response to this agreement
          are subject exclusively to the authority of the courts which
          have jurisdiction at the location of the main corporate
          offices of Noticed.
        </p>`,
        },
        {
          id: "dfgfdkjgdlkgkjjnkj65455465661615165",
          title: "Privacy & Cookies",
          body: `
          <h3>Privacy</h3>
          <p>
                    Noticed places great importance on the protection of your
                    personal data and also strives to process your personal data
                    legally, honestly and transparently.
                  </p>
                  <p>
                    In this privacy statement Noticed sets out which information
                    it collects about you, where the information is used and to
                    whom the information is forwarded. Likewise, you will find
                    here what rights you have and how you can assert them.
                  </p>
                  <p>
                    This privacy statement applies whenever you make use of
                    SHEPRD.
                  </p>

                  <h5>Who is the party responsible for processing?</h5>
                  <p>
                    The party responsible for processing your personal data is:
                  </p>
                  <div>
                    <svg-icon icon="important" />
                    <p>
                      <strong>Noticed Communicatiebureau bvba</strong><br />
                      Lintsesteenweg 105<br />
                      2500 Lier<br />
                      Company ID number: 0806.663.876<br />
                    </p>
                  </div>
                  <p>Referred to in the following as ‘Noticed’</p>
                  <h5>Why does Noticed process your personal data?</h5>
                  <p>
                    Noticed processes your personal data when you make use of
                    its platform SHEPRD.
                  </p>
                  <p>
                    When you make use of SHEPRD, you first need to register. In
                    this case the following personal data will be stored:
                  </p>
                  <ul>
                    <li>Name</li>
                    <li>E-mail address</li>
                    <li>VAT-number</li>
                  </ul>
                  <p>
                    These data will only be used in the framework of customer
                    management and the creation and management of your account
                    on SHEPRD. This processing is necessary for the performance
                    of the agreement between you and Noticed.
                  </p>
                  <p>
                    You understand that you cannot make use of SHEPRD without
                    this data.
                  </p>

                  <h5>How long does Noticed store your personal data?</h5>
                  <p>
                    Noticed will store your personal data as long as is
                    necessary for the fulfilment of the objectives mentioned
                    above or to fulfil any legal obligation to which Noticed is
                    subject.
                  </p>
                  <p>
                    After the cooperation with Noticed is terminated, this
                    period will be 1 month. You decide for yourself about the
                    option of deleting your account. In that case, all of U your
                    personal data will be deleted, with the exception of the
                    parts related to accounting.
                  </p>

                  <h5>With whom does Noticed share your personal data?</h5>
                  <p>
                    Noticed does not share your data with third parties, with
                    the exception of possible sub-contractors who assist Noticed
                    in the performance of the agreement between you and Noticed.
                    So, your account data will be shared with the cloud provider
                    that Noticed works with.
                  </p>
                  <p>
                    In no case will your personal data be shared with third
                    parties with an eye on commercial purposes.
                  </p>
                  <p>
                    Noticed does not share your personal data with countries
                    situated outside of the European Economic Region.
                  </p>

                  <h5>How does Noticed protect your personal data?</h5>
                  <p>
                    Noticed pledges to the best of its ability to take all
                    reasonable measures to assure the security of your personal
                    data so that they are protected against abuse, loss and
                    unauthorized access. These measures are always based on the
                    state of the technical art.
                  </p>

                  <h5>What are your rights?</h5>
                  <p>
                    You have various rights concerning your personal data that
                    we process. You can exercise these rights by contacting us
                    using the contact data as described in Point 7.
                  </p>
                  <p>
                    In the framework of our obligation to check identity, we can
                    ask you to provide us a copy of your personal identity card.
                  </p>
                  <ol>
                    <li>
                      <h6>Right to disclosure and correction</h6>
                      <p>
                        If you want to know which of your personal data Noticed
                        processes and for what purposes, then you can contact
                        us. You can also request that any incorrect personal
                        data be corrected or that your data be changed.
                      </p>
                    </li>
                    <li>
                      <h6>Right to deletion and restriction</h6>
                      <p>
                        You have the right to ask us to delete your personal
                        data. It can be that certain data will be retained by
                        Noticed after your request for deletion. For example,
                        because we have a legal obligation to retain that data
                        for a certain period. If you have justified reasons for
                        it, you can ask us to restrict the processing of your
                        personal data. For example, because you dispute the
                        accuracy of your data.
                      </p>
                    </li>
                    <li>
                      <h6>Right of objection</h6>
                      <p>
                        When the processing of your personal data is based on
                        our justified concern or is in the interest of the
                        fulfilment of some branch of public interest or an
                        interest of public authorities, you can submit a
                        justifiable objection to the processing of your personal
                        data.
                      </p>
                    </li>
                    <li>
                      <h6>Right to data transferability</h6>
                      <p>
                        If we are processing your personal data on the basis of
                        your (expressed) consent or in the framework of the
                        execution of agreement between you and us, then you can
                        ask use to provide the personal data which you have
                        supplied us in a structured, conventional and
                        machine-readable form or to transfer these data to
                        another party responsible for processing, on the
                        condition that the processing is carried out via
                        automated procedures.
                      </p>
                    </li>
                    <li>
                      <h6>Right to withdraw your consent</h6>
                      <p>
                        If the processing of your personal data by Noticed is
                        based on your (expressed) consent, you have at all times
                        the right to revoke this consent. The revocation of your
                        consent, however, does not invalidate the legitimacy of
                        processing prior to the revocation of your consent.
                      </p>
                    </li>
                    <li>
                      <h6>Right to submit a complaint</h6>
                      <p>
                        You have the right to submit a complaint to the Belgian
                        supervising authorities if you have a complaint about
                        the use of your personal data by Noticed.
                      </p>
                      <div>
                        <svg-icon icon="important" />
                        <p>
                          <strong>Data Protection Authority</strong><br />
                          Drukpersstraat 35<br />
                          1000 Brussel<br />
                          Tel: <a href="tel:+3222744800">02/274.48.00</a><br />
                          Fax: <a href="fax:022744835">02/274.48.35</a><br />
                          E-mail:
                          <a href="mailto:contact@apd-gba.be"
                            >contact@apd-gba.be</a
                          ><br />
                        </p>
                      </div>
                    </li>
                  </ol>

                  <h5>Contact</h5>
                  <p>
                    If you have any questions concerning our privacy statement,
                    you can contact us through the following channels:
                  </p>
                  <ul>
                    <li>
                      Per e-mail:
                      <a href="mailto:info@sheprd.com">info@sheprd.com</a>
                    </li>
                  </ul>

                  <h5>Changes</h5>
                  <p>
                    We reserve the right to change this privacy statement from
                    time to time. You will always find the most recent version
                    of it
                    <a href="noticed/policy">here</a>
                  </p>`,
        },
      ],
      isPagesLoading: false,
    };
  },
  created() {
    setDocTitle("policy", this);

    this.getPages();
  },

  methods: {
    close() {
      this.$router.push(`/${this.company}/account`);
    },
    getPages() {
      this.isPagesLoading = true;

      //TO DO fetch

      if (!this.activePage) {
        //is empty
        this.activePage = this.pages[0];
      }

      this.isPagesLoading = false;
    },
    setActivePage(id) {
      if (id) {
        //is existing page
        this.activePage = this.pages.filter((page) => page.id === id)[0];
      } else {
        //is dummy
        this.activePage = this.dummy;
      }
    },
    injectDiv(str, searchStr, div, startItem = 0, dir) {
      let startIndex = 0;
      let index;
      let result = str;
      let count = 0;

      while ((index = result.indexOf(searchStr, startIndex)) > -1) {
        if (startItem <= count) {
          const newIndex = dir === "before" ? index : index + searchStr.length;

          result =
            result.substring(0, newIndex) +
            div +
            result.substring(newIndex, result.length);
        }

        startIndex = index + result.length;
        count += 1;
      }

      //add closing tag
      if (count > 0 && dir === "before") {
        result += "</div>";
      }

      return result;
    },
  },
  computed: {
    userIsAdmin() {
      return this.$store.state.role
        ? this.$store.state.role.name === "Administrator"
        : false;
    },
    editPageBody() {
      //add extra layouting to the html

      if (this.activePage) {
        let body = this.injectDiv(
          this.activePage.body,
          "</h3>",
          `<div class="form-items">`,
          0
        );

        body = this.injectDiv(
          body,
          "<h3>",
          `<div class="form-items">`,
          1,
          "before"
        );

        return body;
      }

      return "";
    },
  },
};
